import React from 'react';
import PropTypes from 'prop-types';
import { InputGroup, FormControl } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import i18n from 'i18next';

import './BaseSearchBar.sass'

const BaseSearchBar = (props) => {
	const { term, onSearch, placeholder = i18n.t('components.searchBar.placeholderSearch') } = props;

	return (
		<InputGroup className="base-search-bar">
			<FormControl
				value={term}
				onChange={onSearch}
				placeholder={placeholder}
				aria-label={placeholder}
				className="base-search-input"
			/>
			<InputGroup.Text className="base-search-icon">
				<FaSearch />
			</InputGroup.Text>
		</InputGroup>
	);
};

BaseSearchBar.propTypes = {
	term: PropTypes.string.isRequired,
	onSearch: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
}

export default BaseSearchBar;
